import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScanStampModal } from "@/components/admin/ScanStampModal";
import { ScanLine } from "lucide-react";

export const StaffScanPanel = ({ accent }) => {
  const [program, setProgram] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/my/loyalty/program").then((r) => setProgram(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="staff-scan-panel" className="max-w-xl space-y-6">
      <div>
        <h2 className="font-heading text-3xl font-bold">Scan stamps</h2>
        <p className="text-slate-400 text-sm mt-1">Scan a diner's stamp card QR to add a stamp or redeem their reward.</p>
      </div>
      {program && !program.active ? (
        <p data-testid="staff-scan-off" className="text-sm text-slate-400 bg-slate-900 border border-slate-800 rounded-2xl p-5">The stamp loyalty program is turned off for this restaurant.</p>
      ) : (
        <button data-testid="staff-open-scanner" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 rounded-2xl px-6 py-4 font-semibold bg-orange-600 hover:bg-orange-700 transition-colors">
          <ScanLine className="h-5 w-5" /> Scan to stamp
        </button>
      )}
      <ScanStampModal open={open} onClose={() => setOpen(false)} onStamped={() => {}} accent={accent} program={program} />
    </div>
  );
};
